export default "__VITE_ASSET__bc49b959__"